(function () {
  var MIN = 2;
  var MAX = 9;

  var key = "zam_bought_seed_v1";
  var seedBase = Number(localStorage.getItem(key));
  if (!seedBase) {
    seedBase = Math.floor(Math.random() * 1000000) + 1;
    localStorage.setItem(key, String(seedBase));
  }

  function seededRandom(seed) {
    seed = (seed * 9301 + 49297) % 233280;
    return seed / 233280;
  }

  function numberForProduct(productId) {
    var seed = seedBase + (Number(productId) || 0) + 202;
    var r = seededRandom(seed);
    return Math.floor(r * (MAX - MIN + 1)) + MIN;
  }

  function apply() {
    document.querySelectorAll(".zam-bought[data-product-id]").forEach(function (el) {
      var pid = el.getAttribute("data-product-id");
      var countEl = el.querySelector(".zam-bought-count");
      if (!countEl) return;
      countEl.textContent = numberForProduct(pid);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
})();